import { getErrorMessage, type ErrorResponse } from '../types/rest';

export interface RequestOptions extends RequestInit {
  /**
   * Set to enable pagination. Denotes how many records you want to paginate at most. Will paginate until this limit is reached.
   * Set to Infinity to not apply any limit (risk paging indefinitely).
   */
  paginateRecords?: number;

  /**
   * Called after each intermediate page is fetched during pagination, with the cumulative data so far.
   * Use this to track progress or render rows incrementally as pages arrive.
   */
  onPageData?: (cumulativeData: unknown[]) => void;

  /**
   * Specify a list of status codes that should not be reported to the logger.
   * This is useful for requests that are expected to fail, such as a missing customer config.
   */
  skippedErrorReportingStatusCodes?: number[];
}

export class FetchError extends Error {
  public response: Response;
  public body: string;
  public errorJson: ErrorResponse | undefined;
  public url: string;
  public options: RequestInit;

  constructor({
    response,
    body,
    errorJson,
    url,
    options,
  }: {
    response: Response;
    body: string;
    errorJson: ErrorResponse | undefined;
    url: string;
    options: RequestInit;
  }) {
    if (errorJson) {
      super(getErrorMessage(errorJson));
    } else {
      super(`${response.status} ${response.statusText}: ${url}\n${body ?? ''}`);
    }
    this.response = response;
    this.body = body;
    this.errorJson = errorJson;
    this.url = url;
    this.options = options;
  }
}
